import { render, staticRenderFns } from "./inventoryLevels.vue?vue&type=template&id=328a2550&scoped=true"
import script from "./inventoryLevels.vue?vue&type=script&lang=js"
export * from "./inventoryLevels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328a2550",
  null
  
)

export default component.exports